import axios from "axios";

// Plans are a ladder: PRO includes everything BASIC has, BASIC includes FREE.
// So the superadmin lists each feature once, on the lowest plan that gets it.
const PLAN_ORDER = ["FREE", "BASIC", "PRO"];

export const fetchFeatures = async (
  feature,
  subs,
  token
) => {
  const current = String(subs || "FREE").toUpperCase();
  const idx = PLAN_ORDER.indexOf(current);
  const plans = idx === -1 ? [current] : PLAN_ORDER.slice(0, idx + 1);

  const results = await Promise.all(
    plans.map((p) =>
      axios
        .get(`${process.env.REACT_APP_BACKEND_URL}/subscription-modal?type=${p}`, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((res) => (Array.isArray(res.data) ? res.data : []))
        .catch(() => [])
    )
  );

  return results.flat().some((f) => f.feature === feature);
};
